/*
 * @Author: Teemo Ding
 * @Date: 2021-08-02 13:29:48
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-03 13:22:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/RemainingStockTextStyle/index.tsx
 */
import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral, i18nGet } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getRemainingStockTextStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onRemainingStockTextStyleReset,
  ongRemainingStockTextStyleChange,
} from '../slice';

const idSet = {
  textColour: suffix + 'remainingStockTextStyleTextColour',
};
const RemainingStockTextStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;

  const _d = useDispatch();

  const handleRemainingStockChange = (textColour) => {
    _d(ongRemainingStockTextStyleChange(textColour));
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          id={idSet.textColour}
          title={getI18n('general.textColour')}>
          <ColorPicker
            onChange={handleRemainingStockChange}
            multi
            id={idSet.textColour}
            color={data}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(RemainingStockTextStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.remainingStockTextStyle,
  getContent: getRemainingStockTextStyle,
  title: getI18nFromGeneral('general.hOCTitle.remainingStockTextStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onRemainingStockTextStyleReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
